export default __webpack_public_path__ + "static/media/upload-select.1895928d.gif";